export const GET_WORKS = "GET_WORKS";
export const GET_WORKS_SUCCESS = "GET_WORKS_SUCCESS";
export const GET_WORKS_FAILURE = "GET_WORKS_FAILURE";

// ===================================================
// ===================================================

export const GET_SINGLE_WORK = "GET_SINGLE_WORK";
export const GET_SINGLE_WORK_SUCCESS = "GET_SINGLE_WORK_SUCCESS";
export const GET_SINGLE_WORK_FAILURE = "GET_SINGLE_WORK_FAILURE";

// ===================================================
// ===================================================

export const CREATE_WORK = "CREATE_WORK";
export const CREATE_WORK_SUCCESS = "CREATE_WORK_SUCCESS";
export const CREATE_WORK_FAILURE = "CREATE_WORK_FAILURE";

// ===================================================
// ===================================================

export const UPDATE_WORK = "UPDATE_WORK";
export const UPDATE_WORK_SUCCESS = "UPDATE_WORK_SUCCESS";
export const UPDATE_WORK_FAILURE = "UPDATE_WORK_FAILURE";

// ===================================================
// ===================================================

export const DELETE_WORK = "DELETE_WORK";
export const DELETE_WORK_SUCCESS = "DELETE_WORK_SUCCESS";
export const DELETE_WORK_FAILURE = "DELETE_WORK_FAILURE";

// ===================================================
// ===================================================
